<template>
    <v-flex sm-12 md-12 xs-12 v-if="showDialog">
        <v-card color="cyan darken-2" class="white--text">
            <v-card-title primary-title>
                <div>
                    <div class="headline mb-0">Evaluación Docente</div>
                    <div>
                        La evaluación docente del periodo {{nombrePeriodo}}. Es una actividad OBLIGATORIA para inscribirte en el próximo periodo.<br>
                        Puedes contestar la evaluación UNICAMENTE del <b>{{fechaInicio}}</b> al <b>{{fechaFin}}</b>.
                    </div>
                </div>
            </v-card-title>
            <v-card-actions>
                <v-btn flat dark @click.native="gotoEncuesta">Realizar evaluación docente</v-btn>
            </v-card-actions>
        </v-card>
    </v-flex>
</template>

<script>
  import axios from 'axios'
  import * as moment from 'moment'

  export default {
    name: 'AvisoEvaluacionDocente',
    mounted () {
      this.validarPeriodoEvaluacionDocente()
    },
    data: () => ({
      showDialog: false,
      nombrePeriodo: ''
    }),
    methods: {
      validarPeriodoEvaluacionDocente () {
        axios.get('alumno/evaluacion-docente/valida-evaluacion')
          .then(resp => {
            if (resp.data.code === 200) {
              this.showDialog = true
              this.nombrePeriodo = resp.data.nombrePeriodo

              moment.locale('es')

              this.fechaInicio = moment(resp.data.fecha_inicio).format('D [de] MMMM [de] YYYY')
              this.fechaFin = moment(resp.data.fecha_fin).format('D [de] MMMM [de] YYYY')
            }
          })
      },
      gotoEncuesta () {
        this.$router.push('/evaluacion-docente/evaluacion-docente')
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/AvisoEvaluacionDocente.vue